import React from 'react';

import { AboutSectionLayout } from '@/layouts/pages/business';
import { t } from '@/utils';

const AboutSection = () => (
  <AboutSectionLayout
    name={t(`pages.business.media.sections.about.name`)}
    title={t(`pages.business.media.sections.about.title`)}
    card1Props={{
      contents: {
        key: t(`pages.business.media.sections.contents.title1`),
        title: t(`pages.business.media.sections.contents.title1`),
        body: t(`pages.business.media.sections.contents.body1`),
      },
      imgSrc: `/pages/business/media/sections/about/bg_1.png`,
    }}
    card2Props={{
      contents: {
        key: t(`pages.business.media.sections.contents.title2`),
        title: t(`pages.business.media.sections.contents.title2`),
        body: t(`pages.business.media.sections.contents.body2`),
      },
      imgSrc: `/pages/business/media/sections/about/bg_2.png`,
    }}
  />
);

export default AboutSection;
